package com.devi3east.bashbuddy.features.common.util

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.KeyboardArrowUp
import androidx.compose.material.icons.filled.KeyboardArrowDown
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.foundation.layout.Column
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text

@Composable
fun SimpleNumberPicker(
    value: Int,
    range: IntRange,
    onValueChange: (Int) -> Unit
) {
    Column(horizontalAlignment = Alignment.CenterHorizontally) {

        IconButton(onClick = {
            val next = if (value == range.last) range.first else value + 1
            onValueChange(next)
        }) {
            Icon(
                imageVector = Icons.Filled.KeyboardArrowUp,
                contentDescription = "Increase"
            )
        }

        Text(
            value.toString().padStart(2, '0'),
            style = MaterialTheme.typography.headlineSmall
        )

        IconButton(onClick = {
            val prev = if (value == range.first) range.last else value - 1
            onValueChange(prev)
        }) {
            Icon(
                imageVector = Icons.Filled.KeyboardArrowDown,
                contentDescription = "Decrease"
            )
        }
    }
}